// A cheering platypus that pops up next to the confetti when the day is done.
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { stickerUrl } from '../lib/stickers';
import { Sticker } from './Sticker';

const CHEERS = ['cheer', 'thumbs-up', 'king', 'you-can-do-it', 'laughing'];

function pick(except?: string): string {
  const options = CHEERS.filter((id) => id !== except);
  return options[Math.floor(Math.random() * options.length)]!;
}

/** Loads the image ahead of time so it shows instantly (and offline) when needed. */
function preload(id: string) {
  const img = new Image();
  img.src = stickerUrl(id);
}

export function StickerBurst({ burst }: { burst: number }) {
  const [next, setNext] = useState(() => pick());
  const [shown, setShown] = useState<{ id: string; key: number } | null>(null);

  useEffect(() => preload(next), [next]);

  useEffect(() => {
    if (burst === 0) return;
    setShown({ id: next, key: burst });
    setNext(pick(next));
    const timer = window.setTimeout(() => setShown(null), 2600);
    return () => window.clearTimeout(timer);
  }, [burst]); // `next` is read once per burst on purpose

  if (!shown) return null;
  return createPortal(
    <div className="sticker-burst" aria-hidden="true">
      <Sticker key={shown.key} id={shown.id} size={180} className="sticker-burst__img" />
    </div>,
    document.body,
  );
}
